import { useSelector } from 'react-redux';
import { requestingSelectors } from 'common/modules/ReactShared';

function useIsPending(actionsToRequest: string[]): boolean {
  return useSelector(requestingSelectors.selectHasRequestingActions(actionsToRequest));
}

export default useIsPending;
